var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckInKellyDarkCircle = function SvgCheckInKellyDarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.955 2.667C8.627 2.667 2.666 8.646 2.666 16c0 7.352 5.961 13.333 13.289 13.333 7.327 0 13.289-5.981 13.289-13.333S23.282 2.666 15.954 2.666Zm5.525 11.572-5.626 5.56a2.213 2.213 0 0 1-3.127-.006l-2.284-2.22A1.115 1.115 0 0 1 10.418 16a1.104 1.104 0 0 1 1.567-.024l2.297 2.234 5.644-5.557a1.106 1.106 0 0 1 1.566.013c.43.438.424 1.142-.012 1.573Z",
    fill: "#249241"
  })));
};
export default SvgCheckInKellyDarkCircle;